import type { NavItem } from '../types/nav';

// ─────────────────────────────────────────────────────────────
// Sidebar navigation — grouped per the "Navigation Prototype"
// design (Claude Design handoff, May 2026).
//
// Order is intentional:
//   Core          — daily-use items (Dashboard, Wells)
//   Organization  — entity hierarchy top-down
//   Equipment     — physical assets
//   Reference     — config / reference data
//
// Change Password is NOT in the main nav anymore — it lives in
// the user-menu dropdown at the bottom of the sidebar. The route
// still exists; the entry just has no `group` so Sidebar.tsx skips it.
// ─────────────────────────────────────────────────────────────

export const navItems: NavItem[] = [
  // ── Core ────────────────────────────────────────────────────
  {
    name: 'Dashboard',
    path: '/dashboard',
    icon: 'LayoutDashboard',
    group: 'Core',
    roles: ['SuperAdmin'],
  },
  {
    name: 'Wells Management',
    path: '/dashboard/wells',
    icon: 'Droplets',
    group: 'Core',
    roles: ['SuperAdmin', 'CompanyAdmin', 'CompanyUser'],
  },

  // ── Organization ───────────────────────────────────────────
  {
    name: 'Companies Management',
    path: '/dashboard/companies',
    icon: 'Building2',
    group: 'Organization',
    roles: ['SuperAdmin'],
  },
  {
    name: 'Locations Management',
    path: '/dashboard/sites',
    icon: 'MapPin',
    group: 'Organization',
    roles: ['SuperAdmin'],
  },
  {
    name: 'Users Management',
    path: '/dashboard/users',
    icon: 'Users',
    group: 'Organization',
    roles: ['SuperAdmin', 'CompanyAdmin'],
  },

  // ── Equipment & Tools ──────────────────────────────────────
  {
    name: 'Inventory Management',
    path: '/dashboard/inventory',
    icon: 'Package',
    group: 'Equipment & Tools',
    roles: ['SuperAdmin'],
  },
  {
    name: 'Tool Models',
    path: '/dashboard/tool-models',
    icon: 'Wrench',
    group: 'Equipment & Tools',
    roles: ['SuperAdmin'],
  },
  {
    name: '3D Model Management',
    path: '/dashboard/3d-models',
    icon: 'Box',
    group: 'Equipment & Tools',
    roles: ['SuperAdmin'],
  },

  // ── Reference ──────────────────────────────────────────────
  {
    name: 'Annotations Management',
    path: '/dashboard/annotations',
    icon: 'StickyNote',
    group: 'Reference',
    roles: ['SuperAdmin'],
  },

  // ── Not in main nav ────────────────────────────────────────
  // Reachable via the user-menu dropdown in the sidebar footer.
  {
    name: 'Change Password',
    path: '/dashboard/change-password',
    icon: 'KeyRound',
    roles: ['SuperAdmin', 'CompanyAdmin', 'CompanyUser'],
  },
];

/** Order in which groups appear in the sidebar. */
export const NAV_GROUP_ORDER = ['Core', 'Organization', 'Equipment & Tools', 'Reference'] as const;
